import React from "react";
import { Check, X } from "lucide-react";
import { VALUE_STACK } from "@/data/content";
import { useCart } from "@/context/CartContext";
import { Reveal, Overline } from "./Reveal";

export const ValueStack = () => {
  const { addToCart } = useCart();
  return (
    <section id="value" data-testid="value-section" className="relative py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <Reveal>
              <Overline index="02">The Value Stack</Overline>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-serif text-3xl md:text-5xl tracking-tight text-white leading-[1.1]">
                Everything you need. <br />
                <span className="gold-text">Included at no extra cost.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-vmuted leading-relaxed max-w-md">
                Most brands sell you a bottle and stop there. With Veda Vitals, your bundle comes
                with the guidance and tools to actually build the habit.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <button
                data-testid="value-buy-btn"
                onClick={() => addToCart("triple")}
                className="mt-8 inline-flex items-center gap-2 rounded-full bg-gold px-8 py-4 text-obsidian font-medium hover:bg-gold-light transition-colors duration-300"
              >
                Get the 3-Tube Bundle · ₹999
              </button>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <div className="glass rounded-3xl overflow-hidden gold-glow">
                <div className="grid grid-cols-[1fr_auto_auto] items-center px-6 md:px-8 py-5 border-b border-white/10 text-xs uppercase tracking-[0.15em] text-vmuted">
                  <span>What you get</span>
                  <span className="text-gold w-24 text-center">Veda Vitals</span>
                  <span className="w-24 text-center">Others</span>
                </div>
                {VALUE_STACK.map((row, i) => (
                  <div
                    key={row.label}
                    data-testid={`value-row-${i}`}
                    className="grid grid-cols-[1fr_auto_auto] items-center px-6 md:px-8 py-4 border-b border-white/5 last:border-0"
                  >
                    <span className="text-white/90 text-sm md:text-base">{row.label}</span>
                    <span className="w-24 grid place-items-center">
                      <span className="h-7 w-7 rounded-full bg-gold/15 grid place-items-center">
                        <Check className="h-4 w-4 text-gold" strokeWidth={2.5} />
                      </span>
                    </span>
                    <span className="w-24 grid place-items-center">
                      {i === 0 ? (
                        <span className="h-7 w-7 rounded-full bg-white/5 grid place-items-center">
                          <Check className="h-4 w-4 text-white/30" strokeWidth={2} />
                        </span>
                      ) : (
                        <span className="h-7 w-7 rounded-full bg-white/5 grid place-items-center">
                          <X className="h-4 w-4 text-white/20" strokeWidth={2} />
                        </span>
                      )}
                    </span>
                  </div>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
